export const PermissionState = {
  granted: 'granted',
  denied: 'denied',
  prompt: 'prompt',
};

export const MediaPermissions = {
  SystemPermissionDenied: 1,
  UserPermissionDenied: 2,
  PermissionGranted: 3,
  PermissionPrompt: 4,
};

export const EndReason = {
  PatientEnd: 'patient-end',
  PatientReject: 'patient-reject',
  PatientInAnotherCall: 'patient-in-another-call',
  DoctorEnd: 'doctor-end',
  DoctorReject: 'doctor-reject',
  LackVideoAudioPermission: 'lack-video-audio-permission',
  LackVideoPermission: 'lack-video-permission',
  LackAudioPermission: 'lack-audio-permission',
  LackMicrophone: 'lack-microphone',
  LackCamera: 'lack-camera',
  LackVideoCameraMicrophone: 'lack-video-camera-microphone',
  Timeout: 'timeout',
};
